module.exports = {
	"ha": "bc",
	"id": 2.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for BC and Health Authority <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018,
					2019,
					2020,
					2021
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1919.5660441714078,
					1925.9099898428076,
					1947.842020636768,
					2285.921386839356,
					2836.196456077228,
					2960.688031741074,
					3259.947634325331,
					3592.195366901743,
					3519.992476919561,
					3681.0551172131527,
					3738.2524580185,
					2989.892754866852,
					{
						"y": 3135.302943430472,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1989.0651310729058,
					2023.4521628229477,
					2018.094117679663,
					2064.107953879765,
					2314.274893802031,
					2687.4968132183676,
					3647.9265348128406,
					4475.75055334046,
					4449.361907735881,
					4922.182957161664,
					9991.749631500308,
					8822.145594730426,
					{
						"y": 9510.68825981093,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 4,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2266.026752052146,
					2287.318564333507,
					2360.939431396786,
					2787.388119283403,
					3138.261228988702,
					3538.883843382961,
					3958.135369596872,
					3905.0716682228126,
					4222.903885480572,
					4461.451862300953,
					4377.793460362268,
					3172.1073093054474,
					{
						"y": 3415.06418722595,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -2,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					4668.273278407065,
					4712.200897726129,
					5001.526011727716,
					6491.935483870969,
					8284.329467424055,
					10694.381579902081,
					12210.448676440948,
					12520.775482903298,
					12375.085294871784,
					12732.937977076383,
					13402.60121858153,
					10821.478748852716,
					{
						"y": 11938.206050989407,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					1867.3865361903154,
					1862.3216961683945,
					1779.41064767989,
					1862.1629861123024,
					1987.6409090080163,
					2121.4495291641706,
					2701.9061212101446,
					2917.7314536539557,
					2795.3769512434815,
					3022.954498959768,
					3151.0300874462723,
					2322.4252394101404,
					{
						"y": 2336.719444690152,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All British Columbia",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2622.216135744969,
					2641.9165763828205,
					2708.178220671935,
					3248.7082223777907,
					3973.0656747177204,
					4716.340390257022,
					5456.068476849033,
					5813.613211915419,
					5741.492745449552,
					6009.010580991958,
					7006.85736665478,
					5703.9367595058275,
					{
						"y": 6150.700225535018,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All British Columbia</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_2_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_2_1.json
// module id = 154
// module chunks = 0